<template>
  <div>
    <div class="modal fade" id="modal-form-cancelar-solicitud-nacional">
      <div class="modal-dialog modal-md">
        <div class="modal-content">
          <div class="modal-header bg-geogo-top-left pt-2 pb-2">
            <h4 class="modal-title text-white">
              Cancelar Solicitud
              <span v-if="form.id">#{{ form.id }}</span>
            </h4>
            <button
              type="button"
              class="close text-white"
              data-dismiss="modal"
              aria-label="Close"
              id="close-modal-cancelar-solicitud-nacional"
              ref="closeModal"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="form-group col-md-12">
                <label for="razon_cancelacion">Razón Cancelación</label>
                <textarea
                  id="razon_cancelacion"
                  v-model="form.razon_cancelacion"
                  style="font-size: 13px"
                  class="form-control form-control-sm"
                  :class="
                    $v.form.razon_cancelacion.$invalid
                      ? 'is-invalid'
                      : 'is-valid'
                  "
                ></textarea>
              </div>
            </div>
          </div>
          <div
            class="modal-footer justify-content-between"
            v-if="!$v.form.$invalid"
          >
            <button type="button" class="btn btn-primary" @click="save()">
              Guardar
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { required } from "vuelidate/lib/validators";

export default {
  name: "SolicitudesNacionalesCancelar",
  data() {
    return {
      form: {
        id: null,
        razon_cancelacion: null,
      },
    };
  },
  validations: {
    form: {
      razon_cancelacion: {
        required,
      },
    },
  },
  methods: {
    save() {
      this.$swal({
        title: "Esta seguro de cancelar esta Solicitud?",
        text: "Los cambios no se pueden revertir!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Si, Cancelar!",
      }).then((result) => {
        if (result.value) {
          this.$parent.cargando = true;
          axios({
            method: "PUT",
            url: "/api/tep/solicitudesNacionales/cancelarSolicitudNacional",
            data: {
              id: this.form.id,
              razon_cancelacion: this.form.razon_cancelacion,
            },
          })
            .then((response) => {
              if (!response.data.error) {
                this.$parent.getIndex();
                this.$refs.closeModal.click();
                this.$swal({
                  icon: "success",
                  title: "Se canceló la Solicitud exitosamente...",
                  toast: true,
                  position: "top-end",
                  showConfirmButton: false,
                  timer: 4000,
                  timerProgressBar: true,
                });
              } else {
                this.$swal({
                  icon: "error",
                  title: response.data.error,
                  toast: true,
                  position: "top-end",
                  showConfirmButton: false,
                  timer: 3000,
                  timerProgressBar: true,
                });
                this.$parent.cargando = false;
              }
            })
            .catch((error) => {
              this.$parent.cargando = false;
              this.$swal({
                icon: "error",
                title: "Ocurrió un error: " + error,
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
                timerProgressBar: true,
              });
            });
        }
      });
    },

    llenar_modal(solicitud) {
      this.form = {
        id: solicitud.id,
        razon_cancelacion: null,
      };
    },
  },
};
</script>
